import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { WarningTriangle } from 'assets/icons';
import { error } from 'constants/variables';

const MyCEFDisableUserModal = ({ options, closeModal }) => {
  const { showModal, title, description, approvalGroups } = options;

  return (
    <DisableUserModal isOpen={showModal} closeModal={closeModal}>
      <div className="fl ">
        <WarningTriangle
          fillColor={error}
          width="30"
          height="26"
          className="mr-5 approvals-modal__icon"
        />

        <h2
          className={`ff-body fw-600 fs-20 lh-1-3 tc-grey-70 mb-14 ${
            description ? '' : 'mb-35'
          }`}>
          {title}
        </h2>
      </div>
      {description && (
        <p className="disable_user--info ff-body fs-16 lh-1-3 tc-grey-70 mb-16 pb-16">
          {description}
        </p>
      )}
      {approvalGroups && (
        <div className="ff-body fs-16 lh-1-3 mb-40">
          {approvalGroups.map(({ route, name }) => (
            <div className="fl jc-sb mb-16" key={name + route}>
              <p className="fw-600" data-testid="group-name">
                {name}
              </p>
              <a href={route} className="td-u">
                Edit Group
              </a>
            </div>
          ))}
        </div>
      )}
      <div className="fl jc-fe">
        <Button
          className="cef-btn cef-btn--red cef-btn--large"
          handleClick={closeModal}>
          Cancel
        </Button>
      </div>
    </DisableUserModal>
  );
};

const DisableUserModal = styled(Modal)`
  background-color: rgba(0, 0, 0, 0.7);
  & > div {
    box-sizing: border-box;
    width: 100%;
    max-width: 475px;
    padding: 32px 24px 28px 30px;
  }
`;

export default MyCEFDisableUserModal;
